import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface FeatureGridItem {
    img: string;
    tagline: string;
    description: string;
}
@Component
export default class EpicFeaturesGrid3 extends Vue {
    @Prop({ default: function() {
        return [{
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/icon1.png',
            tagline: 'Massive Listing',
            description: 'Browse million listings on our app to find your dream house'
        }, {
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/icon2.png',
            tagline: 'Markting Analysis',
            description: 'Follow lastest big data analysis on real estate market'
        }, {
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-download/icon3.png',
            tagline: 'Save & Share',
            description: 'Save and share your and  ideal house with RIFO app'
        }];
    } })
    public featureGridList!: FeatureGridItem[];
}
